export enum PhoneType {
  Home = 'HOME',
  Mobile = 'MOBILE',
  Work = 'WORK',
  Fax = 'FAX',
  Other = 'OTHER',
}
